// src/constants.ts
var GOLDEN_MAJOR = 0.6180339887498949;
var GOLDEN_MINOR = 1 - GOLDEN_MAJOR;
export {
  GOLDEN_MAJOR,
  GOLDEN_MINOR
};
//# sourceMappingURL=constants.js.map